import { render, staticRenderFns } from "./BrandOptionCard.vue?vue&type=template&id=492f4087&scoped=true"
import script from "./BrandOptionCard.vue?vue&type=script&lang=js"
export * from "./BrandOptionCard.vue?vue&type=script&lang=js"
import style0 from "./BrandOptionCard.vue?vue&type=style&index=0&id=492f4087&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "492f4087",
  null
  
)

export default component.exports